import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
}

const IconCloseUi: React.FC<IProps> = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...props}
        >
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1.28229 0.220652C0.989398 -0.0722445 0.514524 -0.072249 0.221628 0.220641C-0.0712679 0.513532 -0.0712725 0.988405 0.221618 1.2813L10.9403 12.0002L0.221973 22.7187C-0.0709171 23.0115 -0.0709133 23.4864 0.221983 23.7793C0.514879 24.0722 0.989754 24.0722 1.28264 23.7793L12.0009 13.0608L22.7192 23.7793C23.0121 24.0722 23.4869 24.0722 23.7798 23.7793C24.0727 23.4864 24.0727 23.0115 23.7799 22.7187L13.0616 12.0002L23.7802 1.2813C24.0731 0.988405 24.0731 0.513532 23.7802 0.220641C23.4873 -0.072249 23.0124 -0.0722445 22.7195 0.220652L12.0009 10.9395L1.28229 0.220652Z"
                  fill="#323232"/>
        </svg>

    );
};

export default IconCloseUi;